import Contact from 'app/i18n/Contact';

import {
  composeValidators,
  textMaxLengthValidator,
  textValidator,
  zipCodeValidator,
} from '../../../components/Form/utils/validators';
export const INVENTORY_FORM_RULES = {
  companyId: {
    validate: textValidator('PROCURE_5002'),
  },
  companyName: {
    validate: composeValidators(
      textValidator('PROCURE_5001'),
      textMaxLengthValidator('PROCURE_5001', 30),
    ),
  },
  firstName: {
    validate: composeValidators(
      textValidator('PROCURE_5010'),
      textMaxLengthValidator('PROCURE_2009', 30),
    ),
  },
  lastName: {
    validate: composeValidators(
      textValidator('PROCURE_5011'),
      textMaxLengthValidator('PROCURE_2010', 30),
    ),
  },
  address: {
    validate: textValidator('PROCURE_2018'),
  },
  addressName: {
    validate: textValidator('PROCURE_5013'),
  },
  addressLine1: {
    validate: textValidator('PROCURE_2018'),
  },
  addressLine2: {
    validate: textValidator('PROCURE_5015'),
  },
  zipCode: {
    validate: composeValidators( 
      textValidator('PROCURE_5020'),
      zipCodeValidator('PROCURE_2012'))
  },
  city: {
    validate: textValidator('PROCURE_5017'),
  },

  state: {
    validate: textValidator('PROCURE_5018'),
  },
};
